import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-full-width-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <div class="flex flex-col h-screen">
      <div class="p-5 flex flex-column flex-auto items-center justify-center">
        <div class="w-full max-w-7xl">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `,
  styles: [],
})
export class FullWidthLayoutComponent {}
